// React for Website

import React from "react";
//outsource
import { Radio, Form, Select } from "antd";

//components

const StaffLevel = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  const options = [
    { label: "Trainee", value: "Trainee" },
    { label: "Level 1", value: "Level 1" },
    { label: "Level 2", value: "Level 2" },
    { label: "Level 3", value: "Level 3" },
    { label: "Level 4", value: "Level 4" },
  ];
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="level">
      <Select options={options} disabled={disabled} />
    </Form.Item>
  );
};

export default StaffLevel;
